import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GlobalContext from '../Context/GloablContext';

const AccessDenied = () => {
    const { isSideNavBar } = useContext(GlobalContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (window.location.pathname !== '/access-denied') navigate('/access-denied');
    }, [navigate]);

    return (
        <div className={`w-full h-screen flex justify-center items-center`}>
            <div className="flex flex-col justify-center items-center">
                <img
                    src="/images/AccesDenied.svg"
                    alt="Access Denied"
                    className="object-contain"
                />
                <h2 className="text-base font-semibold -mt-[70px]">Access Denied</h2>
                <p className="text-base mt-2">
                    You do not have permission to access this page.
                </p>
            </div>
        </div>
    );
};

export default AccessDenied;
